const functionData = {};

export function getFunctionData(key) {
  if (!Object.hasOwn(functionData, key)) {
    console.error(`関数データに${key}が存在しません`);
    return null;
  }
  return functionData[key];
}

export function setFunctionData(key, func) {
  functionData[key] = func;
}

export function deleteFunctionData(key) {
  if (!Object.hasOwn(functionData, key)) {
    console.error(`関数データに${key}が存在しません`);
    return;
  }
  delete functionData[key];
}